import { InformationCircleIcon, PencilIcon, TrashIcon } from '@heroicons/react/outline';
import { FieldArray, Form, Formik } from 'formik';
import { useState } from 'react';
import Button from '../../SharedComponents/Button/Button';
import Text from '../../SharedComponents/Inputs/components/Text';
import Modal from '../../SharedComponents/Modal/Modal';
import { PlusIcon } from '@heroicons/react/solid';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import * as Yup from 'yup';
import { DateTime } from 'luxon';

export default function TalabInformationModal(props) {
  const [isOpen, setIsOpen] = useState(false);
  const { name, infoId, mutationData, message } = props;
  const sharedProps = { isOpen, setIsOpen, name, infoId, mutationData, message };
  return (
    <>
      <div className="inline-block">
        <Button
          type="button"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          text={<InformationCircleIcon className="h-4" />}
          className="bg-[#bae6fd] text-[#075985] p-1 py-1 hover:bg-[#96d7f8] rounded mt-0"
        />
      </div>

      {isOpen && <ModalContainer {...sharedProps} />}
    </>
  );
}

const ModalContainer = (props) => {
  const queryClient = useQueryClient();
  const { isOpen, setIsOpen, infoId, mutationData, message } = props;
  const sharedProps = { isOpen, setIsOpen };

  const initialValues = { id: infoId };
  const addPrintingStatus = async (e) => {
    let ses = {
      statusId: e.statusId ? e.statusId : null,
      userId: e.statusId ? e.id : null,
      name: e.fullName,
      createdDatestring: DateTime.now().toISODate(),
    };

    const { data } = await axios.post(`/UserAccount/AddPrintingStatus`, ses);

    return data;
  };

  const mutation = useMutation(addPrintingStatus, {
    onSuccess: (data, values) => {
      // setPrintId(data.outId);
      // handlePrint();
      setTimeout(() => {
        window.open(`/information/info?data=${JSON.stringify({ ...values, outId: data.outId })}`, '_blank');
      }, 500);
      setIsOpen(false);
    },
  });
  const onSubmit = (e) => {
    mutation.mutate(mutationData);
  };
  return (
    <>
      {isOpen && (
        <Modal modalTitle="ملاحظات الطلب" {...sharedProps}>
          <Formik onSubmit={onSubmit} initialValues={initialValues}>
            {({ values, errors }) => {
              return (
                <Form className="rtl" dir="rtl">
                  {' '}
                  <div className="flex flex-col space-y-4">
                    <span className="text-right my-4">{message} </span>
                  </div>
                  <div className="flex space-x-2 space-x-reverse">
                    {/* <Button
                      type="submit"
                      text="طباعة"
                      loading={mutation.isLoading}
                      disabled={mutation.isLoading}
                      className="bg-green-500 hover:bg-green-600 w-1/4"
                    /> */}
                    <Button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                      text="اغلاق"
                      className="bg-red-500 hover:bg-red-600 w-1/4"
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal>
      )}
    </>
  );
};

const mutationFunction = async (e) => {
  const { data } = await axios.post(`ComplainDepartment/Delete`, {
    id: e.id,
  });
  return data;
};
